import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getCapitalNeed } from '#/graphql/queries';
import type { GetCapitalNeedQuery } from '#/graphql/types';

export const GET_CAPITAL_NEED = gql(getCapitalNeed);

const useCapitalNeedQuery = (id?: string) => {
  const query: QueryResult<GetCapitalNeedQuery> = useQuery(GET_CAPITAL_NEED, {
    variables: { id },
    skip: !id || id === 'new',
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useCapitalNeedQuery;
